import React from "react"
import { useParams } from "react-router-dom"
import { Loader } from "@mantine/core"
import {
    GotvCampaignFooter,
    DEFAULT_SOCIAL_HEADER,
} from "QuorumGrassroots/widgets/GotvCampaignFooter/GotvCampaignFooter"
import { useGotvSocialSharing } from "QuorumGrassroots/widgets/GotvCampaignFooter/useGotvSocialSharing"
import { CampaignSubpageHeader } from "QuorumGrassroots/widgets/ReusableComponents/CampaignSubpageHeader"
import {
    SubpageContainer,
    LoadingContainer,
    Wrapper,
} from "QuorumGrassroots/pages/campaign/candidates/CandidatesPage.styles"
import { useCampaign } from "QuorumGrassroots/services/grassrootsCampaign"
import { CampaignTitleSubtitle } from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CampaignTitleSubtitle/CampaignTitleSubtitle"

export const CandidatesPage: React.FC = () => {
    const { id } = useParams<{ id: string }>()

    const { data: campaign, isLoading: isCampaignLoading, isError: isCampaignError } = useCampaign(id)

    const socialPlatforms = useGotvSocialSharing({
        socialMediaPlatforms: campaign?.social_media_platforms,
        shareUrl: window.location.href,
        shareText: campaign?.social_share_text ?? `Help ${campaign?.name} get out the vote!`,
        imageUrl: campaign?.social_image_url,
    })

    if (isCampaignLoading)
        return (
            <Wrapper>
                <LoadingContainer>
                    <Loader size="sm" /> Loading...
                </LoadingContainer>
            </Wrapper>
        )

    if (isCampaignError)
        return (
            <Wrapper>
                <SubpageContainer>
                    <p>Error loading campaign. Please try again later.</p>
                </SubpageContainer>
            </Wrapper>
        )

    return (
        <SubpageContainer>
            <CampaignTitleSubtitle campaign={campaign} />
            <CampaignSubpageHeader
                title="Explore Candidates"
                backUrl={`/campaign/${id}`}
                dataCy="explore-candidates-header"
            />

            {/* Content will be added in future tickets */}

            <GotvCampaignFooter
                socialPlatforms={socialPlatforms}
                socialHeading={campaign.social_header ?? DEFAULT_SOCIAL_HEADER}
            />
        </SubpageContainer>
    )
}
